<template>
  <div class="about_box">
    <sellheader></sellheader>

    <div class="content">
      <div
        :style="{ backgroundImage: 'url(' + backgroundImg + ')' }"
        style="background-size: cover; min-height: 300px; position: relative"
        class="inner-banner"
      >
        <section class="w3l-breadcrumb text-left">
          <div class="container">
            <ul class="breadcrumbs-custom-path">
              <li><a href="./">首页</a></li>
              <li class="fa fa-chevron-right mx-2" aria-hidden="true">
                <a href="/about"> 关于我们  </a>
              </li>
              <!-- <li class="active">
                <span
                  class="fa fa-chevron-right mx-2"
                  aria-hidden="true"
                ></span>
                关于我们
              </li> -->
            </ul>
          </div>
        </section>
      </div>

      <section
        style="width: 90%; margin: auto"
        class="w3l-index3"
        v-if="muneActive == giveId(0)"
      >
        <div class="midd-w3 py-5">
          <div class="container py-lg-5 py-md-3">
            <div class="row">
              <div class="col-lg-12 pl-lg-5">
                <div class="header-title">
                  <span class="sub-title">关于我们</span>
                  <h3 style="line-height: 100px" class="hny-title text-center">
                    广东万泰科创药业有限公司
                  </h3>
                </div>

                <div
                  style="width: 90%; margin: auto"
                  class="text"
                  v-html="companyInfo"
                ></div>
                <div
                  style="width: 90%; margin: auto"
                  class="company_image_list"
                >
                  <el-carousel
                    :interval="2000"
                    indicator-position="none"
                    type="card"
                    :autoplay="true"
                    height="320px"
                  >
                    <el-carousel-item
                      v-for="(item, index) in companyImageList"
                      :key="index"
                    >
                      <div class="images">
                        <el-image
                          style="width: 100%; height: 320px"
                          fit="fill"
                          :src="item.companyImageUrl"
                        ></el-image>
                      </div>
                      <div class="sh_info">
                        <span>{{ item.companyImageName }}</span>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-servicesblock py-5" v-if="muneActive == giveId(2)">
        <history :datatext="linshi"></history>
      </section>
      <!-- 视频 -->
      <!-- <section class="w3l-form-25-section" id="about3">
        <div class="form-25-mian">
          <div class="py-5">
            <div class="row py-5">
              <videos></videos>
            </div>
          </div>
        </div>
      </section> -->

      <section class="w3l-team-main" v-if="muneActive == giveId(4)">
        <div class="team py-5">
          <div class="container py-lg-5">
            <div class="header-title mb-4">
              <span class="sub-title">核心团队</span>
            </div>
            <div
              style="width: 90%; margin: auto"
              v-for="(item, index) in ldList"
              :key="index"
            >
              <div class="ldtype" style="text-align: center; padding: 20px">
                <h3>{{ item.type == 1 ? "领军团队" : "专家团队" }}</h3>
              </div>
              <div class="row team-row">
                <div
                  v-for="(items, indx) in item.data"
                  :key="indx"
                  class="col-lg-3 col-6 team-wrap mt-lg-5 mt-4"
                >
                  <el-tooltip placement="top">
                    <div style="width: 200px" slot="content">
                      {{ items.sketch }}
                    </div>
                    <div class="team-member text-center">
                      <div class="team-img">
                        <img
                          :src="items.picUrl"
                          alt="暂无"
                          class="radius-image"
                        />
                      </div>
                      <a href="javascript:void(0)" class="team-title">{{
                        items.name
                      }}</a>
                      <p>{{ items.sketch.substring(0, 11) }}...</p>
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-team-main" v-if="muneActive == giveId(5)">
        <div class="team py-5">
          <div class="container py-lg-5">
            <div class="header-title mb-4">
              <span class="sub-title">同创共享</span>
            </div>
            <div class="row team-row">
              <div
                v-for="(item, indx) in hzList"
                :key="indx"
                class="col-lg-3 col-6 team-wrap mt-lg-5 mt-4"
              >
                <el-tooltip placement="top">
                  <div style="width: 200px" slot="content">
                    {{ item.enterpriseName }}
                  </div>
                  <div class="text-center">
                    <div class="team-img">
                      <img :src="item.picUrl" alt="暂无" class="radius-image" />
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-team-main" v-if="muneActive == giveId(6)">
        <div class="team py-5">
          <div class="container py-lg-5">
            <div class="header-title mb-4">
              <span class="sub-title">荣誉资质</span>
            </div>
            <div v-for="(item, index) in ryList" :key="index">
              <div v-if="item.honorsType != '3'">
                <!-- <div class="ldtype" style="text-align: center; padding: 20px">
                  <h3>{{ item.honorsType == 1 ? "创新成果" : "知识产权" }}</h3>
                </div> -->
                <div class="row team-row">
                  <div
                    v-for="(items, indx) in item.data"
                    :key="indx"
                    class="col-lg-2 col-6 team-wrap mt-lg-5 mt-4"
                  >
                    <el-tooltip placement="top">
                      <div style="width: 200px" slot="content">
                        {{ items.describes }}
                      </div>
                      <div class="team-member text-center">
                        <div class="team-img">
                          <el-image
                            @click="seebigimg(items.picUrl)"
                            style="width: 100px; height: 100px"
                            :src="items.picUrl"
                            :preview-src-list="srcList"
                          >
                          </el-image>
                        </div>
                        <p style="font-size: 11px">
                          {{ subString(items.describes) }}
                        </p>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-team-main" v-if="muneActive == giveId(7)">
        <div class="team py-5">
          <div class="container py-lg-5">
            <div class="header-title mb-4">
              <span class="sub-title">社会责任</span>
            </div>
            <div class="row team-row">
              <div class="col-lg-12 col-12 team-wrap mt-lg-5 mt-4">
                <div style="width: 90%; margin: auto">
                  <el-carousel
                    :interval="4000"
                    indicator-position="none"
                    type="card"
                    height="320px"
                  >
                    <el-carousel-item
                      v-for="(item, index) in zrList"
                      :key="index"
                    >
                      <div class="images">
                        <el-image
                          style="width: 100%; height: 320px"
                          fit="fill"
                          :src="item.picUrl"
                        ></el-image>
                      </div>
                      <div class="sh_info">
                        <span>{{ item.describes }}</span>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-team-main" v-show="muneActive == giveId(1)">
        <div class="team py-5">
          <div class="container py-lg-5">
            <div class="header-title mb-4">
              <span class="sub-title">使命和愿景</span>
            </div>
            <div class="row team-row">
              <div class="col-lg-12 col-12 team-wrap mt-lg-5 mt-4 ui-timeLine " >
                <div class="item_list" style="margin-bottom: 30px">
                  <h3>使命</h3>
                  
                  <div id="aaaa" class="text">
                    <p class="ql-editor cboxs" :style="{left:show+'vw'}" v-html="shiming"></p>
                  </div>
                </div>

                <div class="item_list" style="margin-bottom: 30px">
                  <h3>愿景</h3>
                  <div style="width: 90%; margin: auto" class="text">
                    <p class="ql-editor cboxs" :style="{left:show+'vw'}" v-html="yuan"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 企业文化 -->
      <section class="w3l-team-main" v-show="muneActive == giveId(3)">
          <div>
            <culture></culture>
          </div>
      </section>


    </div>
    <footers></footers>
    <div class="right_mune">
      <ul>
        <li
          v-for="(item, index) in menuList"
          :key="index"
          :class="muneActive == item.path ? 'mune_active' : ''"
          @click="section(item.path)"
        >
          {{ item.menuName }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import sellheader from "@/views/home/header/index.vue";
import history from "@/views/about/history.vue";
import footers from "@/views/footer/index.vue";

import Culture from "@/views/culture/index.vue"

import { articleList } from "@/api/article/index";
import { teamList, honorsDutylist } from "@/api/team/index";

import { listMenu } from "@/api/menu/index.js";

import { cooperationList } from "@/api/cooperation/index";

import { bannerList } from "@/api/menu/index.js";

import { imagelisturl } from "@/api/video/index";

export default {
  components: {
    sellheader,
    history,
    Culture,
    // videos,
    footers,
  },
  data() {
    return {
      show:100,
      backgroundImg: "",
      srcList: [],
      menuList: [],
      muneActive: "about1",
      hzList: [],
      ryList: [],
      ldList: [],
      zrList: [],
      shiming: "",
      yuan: "",
      linshi: "",
      queryParams: {
        pageNum: 1,
        pageSize: 1,
      },
      cooqueryParams: {
        pageNum: 1,
        pageSize: 24,
        picType: 2,
      },
      imgqueryParams: {
        picType: "about",
      },
      companyInfo: {},
      companyImageList: {},
    };
  },
  watch: {
    $route(to, from) {
      let selectId = to.query.selectid;

      if (!selectId) {
        this.muneActive = "about1";
      } else {
        this.section(selectId);
        // this.getTitles(selectId)
      }
    },
  },
  created() {
    this.getArticleList();
    let selectid = this.getUrlKey("selectid");
    if (selectid != null) {
      this.section(selectid);
      // this.getTitles(selectid)
    }

  },
  mounted() {
    this.getteamList();
    this.getRongyu();
    this.getMenuList();
    this.getCooperationData();
    this.getBannerList();
    this.getCompanyimageList();
  },
  methods: {


    getCompanyimageList() {
      imagelisturl().then((res) => {
        this.companyImageList = res.rows;
      });
    },

    getBannerList() {
      bannerList(this.imgqueryParams).then((res) => {
        if (res.total > 0) {
          this.backgroundImg = res.rows[0].picUrl;
        }
      });
    },
    // getTitles(path){
      
    //     var liteTitle = this.menuList.filter((res =>{
    //       return res.path == path
    //     }))
    // },
    section(ids) {
      if(ids == "about7"){
        setTimeout(() => {
          this.show = 0
        }, 10);
        
      }
      else{
        setTimeout(() => {
          this.show = 100
        }, 10);
      }
      this.muneActive = ids;
    },
    getCooperationData() {
      cooperationList(this.cooqueryParams).then((res) => {
        this.hzList = res.rows;
      });
    },
    //获取菜单
    getMenuList() {
      listMenu().then((res) => {
        const menuList = this.handleTree(res.rows, "id").filter(
          (res) => res.path == "about"
        )[0].children;

        this.menuList = menuList.sort((a, b) => {
          return a.orderNum - b.orderNum;
        });
      });
    },
    giveId(i) {
      if (this.menuList.length > 0) {
        return this.menuList[i].path;
      }
    },

    seebigimg(url) {
      this.srcList.push(url);
    },
    // 获取企业介绍
    getArticleList() {
      articleList().then((res) => {
        this.Info = res.rows;
        this.companyInfo = this.handData(1)[0].articleContent;
        this.shiming = this.handData(3)[0].articleContent;
        this.yuan = this.handData(4)[0].articleContent;
        this.linshi = this.handData(2)[0].articleContent;
      });
    },
    // 获取团队
    getteamList() {
      teamList().then((res) => {
        this.ldList = this.handteamData(res.rows, "type").reverse();
      });
    },
    getRongyu() {
      honorsDutylist().then((res) => {
        this.ryList = this.handteamData(res.rows, "honorsType");
        this.zrList = this.ryList.filter(
          (res) => res.honorsType == "3"
        )[0].data;
      });
    },

    // 处理数据
    handteamData(data, types) {
      var map = {},
        dest = [];
      for (var i = 0; i < data.length; i++) {
        var ai = data[i];
        if (!map[ai[types]]) {
          dest.push({
            [types]: ai[types],
            data: [ai],
          });
          map[ai[types]] = ai;
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j];
            if (dj[types] == ai[types]) {
              dj.data.push(ai);
              break;
            }
          }
        }
      }
      return dest.reverse();
    },
    handData(type) {
      if (this.Info.length > 0) {
        return this.Info.filter((res) => res.articleType == type);
      }
    },
    //截取字段
    subString(str) {
      if (str != "" && str != null) {
        if (str.length > 9) {
          return str.substring(0, 9);
        } else {
          return str;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.row{
  position: relative;
  overflow: hidden;
}

.cboxs {
  position: relative;
  left: 100vw;
  transition: left 1s;
  padding: 10px;
  border-radius: 10px;
  // box-shadow: 3px 3px 8px #ccc;
  // background: linear-gradient(180deg, #00758e 0, #018fac 100%);
}
.transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }

.text {
  letter-spacing: 0.2em;
  line-height: 2.6em;
  text-indent: 40px;
  color: #666;
}
@media screen and (max-width: 990px) {
  .right_mune {
    display: none;
  }
}
.right_mune {
  width: 8%;
  // height: 400px;
  position: fixed;
  right: 10px;
  top: 32%;
  font-size: 18px;
  background: #fff;
  border-radius: 3px;
  text-align: center;
  -moz-box-shadow: 0px 0px 8px #333333;
  -webkit-box-shadow: 0px 0px 8px #333333;
  box-shadow: 0px 0px 8px #333333;
  ul li {
    cursor: pointer;
    width: 100%;
    height: 60px;
    line-height: 60px;
    color: #651984;
    position: relative;

    // background: red;
  }
  ul li:hover {
    background: linear-gradient(180deg, #0a529b 0,#0a529b 100%);
    color: #fff;
  }
  .mune_active {
    background: linear-gradient(180deg, #0a529b 0,#0a529b 100%);
    color: #fff;
  }
  ul li::before {
    content: "";
    width: 60%;
    height: 1px;
    background: #0a529b;
    position: absolute;
    bottom: 1px;
    left: 20%;
  }
  ul li:last-child::before {
    display: none;
  }
}
// .mt-3 {
//   letter-spacing: 0.2em;
//   line-height: 2.6em;
//   text-indent: 40px;
//   color: #666;
// }
.team-member {
  width: 70%;
  height: auto;
  margin: auto;
  padding: 10px;
}
.team-member:hover {
  background: #0a529b;
  border-radius: 5px;
  color: red !important;
}
.el-tooltip__popper {
  background: #0a529b !important;
}
.team-member:hover .seebigimg {
  display: block;
}

// 社会责任
.el-carousel__item h3 {
  // color: #475669;
  font-size: 14px;
  // opacity: 0.75;
  // line-height: 200px;
  margin: 0;
}
.images {
  width: 100%;
  height: 320px;
  // background: red;
}
.sh_info {
  width: 100%;
  height: 60px;
  color: #fff;
  background: rgba(0, 0, 0, 0.555);
  position: absolute;
  bottom: 0px;
  left: 0px;
  padding: 10px;
  line-height: 20px;
  // span{
  //   padding: 3px 10px 3px 10px;
  // }
}

// .el-carousel__item:nth-child(2n) {
//   background-color: #99a9bf;
// }

// .el-carousel__item:nth-child(2n + 1) {
//   background-color: #d3dce6;
// }
</style>